module.exports = {
  nonWriteoffList: '未销账列表',
  writeoffList: '销账查询',
  selectHedgingTheInvoice: '请查询并选择要对冲的',
  return: '返回',
  query: '查询',
  writeOffs: '销账',
  confirm: '确认',
  hedgingWriteOffs: '对冲销账',
  actualReceiptAndPayment: '实收实付',
  revenueAndExpenditureMethod: '收付方式',
  all: '全部',
  receivables: '应收',
  payables: '应付',
  feeType: '费用类型:',
  domestic: '国内',
  international: '国外',
  writeOffMode: '销账模式',
  charges: '费用',
  invoice: '发票',
  bill: '账单',
  accountStatement: '对账单',
  paymentRequest: '付款申请',
  revenueAndExpenditureDate: '收付日期',
  writeOffSerialNumber: '销账流水号',
  settleAccountsTo: '结算对象',
  chargeRemark: '费用备注',
  applyState: '申请状态',
  applicationNo: '申请单号',
  businessNumber: '业务编号',
  theOppositeSideInvoiceNo: '对方发票号',
  consignationCompany: '委托单位',
  settlementAgent: '结算代理',
  currency: '币种',
  applicant: '申请人',
  businessType: '业务类型',
  dateOfApplication: '申请日期',
  businessDate: '业务日期',
  operation: '操作',
  sales: '销售',
  wroteOffOrNot: '是否已核销',
  businessReferenceNumber: '业务参考号',
  businessStatus: '业务状态',
  separateNumber: '分单号',
  paymentNotificationNo: '付款通知号',
  applicationDepartment: '申请部门',
  paymentPeriod: '付款期限',
  amount: '金额',
  theAmountOfWriteOffs: '核销金额',
  approvalStatus: '审批状态',
  businessAuditor: '业务审核人',
  businessAuditDate: '业务审核时间',
  departmentAuditor: '部门审核人',
  departmentAuditDate: '部门审核时间',
  officeAuditor: '商务审核人',
  officeAuditDate: '商务审核时间',
  financialAuditor: '财务审核人',
  financialAuditDate: '财务审核时间',
  financeVerifyDate: '财务审核日期',
  verificationStatus: '核销状态',
  remark: '备注',
  totalAmountNtWrittenOff: '未销金额合计',
  methodOfPayment: '付款方式',
  claimState: '认领状态',
  prePayment: '是否预收款',
  lastTimeBalance: '上次余额',
  thisTimeWriteOff: '本次核销',
  thisTimeBalance: '本次余额',
  otherCurrency: '其他币种',
  paymentMethod: '收款方式',
  bankReceiptStatus: '水单状态',
  ourSideBank: '我方银行',
  ourSideAccount: '我方账号',
  proofNo: '凭证号',
  usePaymentRecord: '使用付款记录',
  paymentAmount: '付款金额',
  receiptAmount: '收款金额',
  theOppositeSideCompany: '对方单位',
  theOppositeSideBank: '对方银行',
  theOppositeSideAccount: '对方账号',
  exchangeGainsAndLosses: '汇兑损益',
  financialCharges: '财务费用',
  oddment: '零头短账',
  originalCurrencyExchangeDifference: '原币汇差',
  writeOffRemarks: '销账备注',
  paymentReceivedDate: '收款日期',
  paymentDate: '付款日期',
  confirmToWriteOff: '确定销账',
  cancel: '取消',
  totalGainsAndLosses: '汇总损益',
  date: '日期',
  method: '方式',
  use: '使用',
  cancelUsed: '取消使用',
  record: '记录',
  chargeItem: '费用名称',
  reconciliationStatus: '对账状态',
  type: '类型',
  writeOffExchangeRate: '核销汇率',
  total: '总计',
  confirmedCharge: '已确认费用',
  subTotal: '小计',
  invoiceNo: '发票号码',
  invoiceHeader: '发票抬头',
  invoiceDate: '开票日期',
  revenueAndExpenditureType: '收付类型',
  billNo: '账单号',
  accountStatementNo: '对账单号',
  billType: '账单类型',
  useReceiptRecord: '使用收款记录',
  cancelUsedReceiptRecord: '取消使用收款记录',
  cancelUsedPaymentRecord: '取消使用付款记录',
  mbl: '主单号',
  itemNo: '项目编号',
  bankReceiptNo: '银行水单号',
  settlementCompany: '结算单位',
  solicitationType: '揽货类型',
  writeOffPerson: '销账人',
  amountRange: '金额区间',
  writeOffDate: '销账日期',
  RecheckDate: '复核日期',
  advanceMoneyOrNot: '是否代垫',
  recheckOrNot: '是否复核',
  proofOrNot: '是否生成凭证',
  proofDate: '凭证日期',
  paymentType: '支付类型',
  prepaidOrNot: '是否预付',
  theAmountOfWrittenOff: '已销金额',
  balance: '余额',
  actualReceiptAmount: '实收金额',
  actualPaymentAmount: '实付金额',
  creator: '创建人',
  recheck: '复核',
  invalid: '作废',
  invoicingInformation: '开票信息',
  unchecked: '取消选中',
  writeOffCurrency: '核销币种',
  chargeOriginalCurrency: '费用原币种',
  chargeOriginalAmount: '费用原金额',
  chargeOriginalExchangeRate: '费用原汇率',
  rmbAmount: '人民币',
  usdAmount: '美元',
  cancelRecheck: '取消复核',
  editWriteOff: '修改销账',
  cancelWriteOff: '撤销销账',
  viewDetails: '查看明细',
  exportExcel: '导出明细表',
  proof: '凭证',
  refreshRate: '刷新汇率',
  refreshActualReceiptAndPaymentAmount: '刷新实际收付金额',
  writeOffType: '销账类型',
  vesselVoyage: '航名/航次',
  containerSizeAmount: '箱型/箱量',
  monetaryEquivalent: '折算金额',
  customerService: '客服',
  totalWriteOffs: '核销总计',
  totalEquivalent: '折算总计',
  exportToExcel: '导出Excel',
  exportPDF: '导出PDF',
  print: '打印',
  close: '关闭',
  dayOfCreditTerm: '账期（天）',
  billPaymentNo: '付款通知号',
  totalCurrency: '分币种合计',
  rateBy: '销账汇率',
  rateByInvoice: '按发票汇率',
  rateByAverage: '按平均汇率',
  businessCreateDate: '业务创建日期',
  invoicingStatus: '开票状态',
  searchReqCondition: '查询条件必须选择一个',
  dateTo: '至',
  lockCheckBoxDate: '查询两年外数据',
  queryLotsOfData: '查询两年外数据',
  writeOffDateNotEmpty: '销账日期不能为空!',
  unlockWriteOffDateQuery: '若选的销账日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？',
  voucherNo: '凭证号',
  voucherCreateDate: '凭证创建日期',
  chargeSettleAccountsTo: '费用结算单位',
  update: '更新',
  strip: '条',
  targetVoucherNo: '对方凭证号',
  voucherDate: '凭证日期2',
  sourceRateDiff: '原币汇差',
  warehouseNo: '进仓编号',
  userDefinedField1: '自定义字段1',
  userDefinedField2: '自定义字段2',
  userDefinedField3: '自定义字段3',
  havingInvoiceingNoOrNot: '是否有发票号',
  selectActualReceiptAndPayment: '选择实收实付',
  noCurrencyRate: '找不到币种 {0} 的汇率，请及时维护相关汇率！',
  selectMethodOfPayment: '请选择付款方式.',
  selectOurSideBank: '请选择我方银行.',
  rateByCharge: '按费用汇率',
  preExchangeDifference: '预估汇差',
  bankWaterNo: '银行水单号',
  ReceivableSoldAmount: '应收已销金额',
  PayableSoldAmount: '应付已销金额',
  ActualAmountReceivable: '应收实收金额',
  ActualAmountPayable: '应付实付金额',
  ChargeOriginTotalAmount: '费用原总金额',
  FinancialExpensesBeAllocated: '是否分摊财务费用',
  FinanceExpensesAllocation: '财务费用分摊',
  ChargingDirection: '收付方向',
  SelectChargeItem: '请选择收费项目',
  SelectAccountObject: '请选择结算单位',
  FinanceChargeShareJobTip: '勾选后，销账时自动将财务费用平均分摊到本次核销的所有业务',
  NotSyncCannotModify: '已同步云平台的数据无法修改或撤销！',
  invoiceTitle: '开票抬头',
  writeoffMatchStatus: '核销状态',
  matchStatusUnmatched: '未匹配',
  matchStatusAuto: '匹配已自动核销',
  matchStatusManual: '手动核销',
  matchStatusNoNeed: '无需核销',
  matchStatusReason: '修改核销状态原因',
  writeoffSeqNoSource: '销账流水号来源',
  sourceImport: '导入',
  sourceSystem: '系统',
  modifyMatchStatus: '修改核销状态',
  modifyStatus: '修改状态',
  modifyReason: '修改原因',
  confirmModify: '确认修改',
  modifySuccess: '成功修改{0}条核销状态',
  lockedCannotModify: '已锁定，不可修改',
  containsLockedStatus: '包含已锁定状态，请选择【未匹配】状态',
  pleaseSelectUnmatched: '请选择【未匹配】状态的记录',
  selectAtLeastOne: '请至少选择一条记录'
}
